const HOST = process.env.VUE_APP_TEST_HOST || '';
// const pyOnlineUlr = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : HOST
const pyOnlineUlr = process.env.NODE_ENV === 'development' ? 'https://test.xiaohoucode.com' : HOST
export default {
  baseUrl: "/api",
  scratchUrl: `${HOST}/scratch/v3/`,
  mblockUrl: `${HOST}/mblock/`,
  pyUrl: `${HOST}/py-editor/`,
  pyOnlineUrl: `${pyOnlineUlr}/xhpython-web/#/competition/online`,
  pyCmUrl: `${pyOnlineUlr}/wonder-land/`,
  cppUrl: `${HOST}/cpp-editor/`,
  cmUrl: `${process.env.VUE_APP_URL}/api/competition/cm/challenge/`,
};


export const communityUrl = {
  scratchUrl: `${HOST}/community/scratch/v3/`,
  pyUrl: `${HOST}/community/py-editor/`,
};
